import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MyProfileComponent } from './my-profile/my-profile.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { PersonalDetailComponent } from './personal-detail/personal-detail.component'
import { CustomerAccountComponent } from './customer-account/customer-account.component'
import { OrderDetailComponent } from './order-detail/order-detail.component'
import { NotifyEmailComponent } from './notify-email/notify-email.component'
import { I18nModule, ConfigModule } from '@spartacus/core'
import { NgSelectModule } from '@ng-select/ng-select'
import { RoleMatrixModule } from './personal-detail/role-matrix/role-matrix.module'
import { environment } from '../../../../environments/environment'

@NgModule({
  //  declarations: [MyProfileComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    I18nModule,
    NgSelectModule,
    RoleMatrixModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['myProfile'],
        },
      },
    }),
  ],
  declarations: [
    MyProfileComponent,
    PersonalDetailComponent,
    CustomerAccountComponent,
    OrderDetailComponent,
    NotifyEmailComponent,
  ],
})
export class MyProfileModule {}
